import withVistaDatosPersonales from "../../hoc/Docentes/withVistaDatosPersonales";
import VistaDatosPersonales from "../../view/components/RegistroUsuarios/DatosPersonales/VistaDatosPersonales";

export default withVistaDatosPersonales(VistaDatosPersonales);